import { success, failure, request } from 'app/actions';
import * as actions from './studentSimulatedActions';
import * as helpers from './studentSimulatedHelpers';

const initialState = {
  evaluations: [],
  evaluation: null,
  years: [],
  status: [],
  isLoading: false,
  hasError: false,
  error: '',
  forbidden: undefined,
  groups: [],
  filtersComponents: [],
  gradeByDiscipline: [],
  gradeReportStudent: {},
  questionsComponent: [],
  alternativeReport: [],
  cicleStudent: [],
  gradeDetailStudent: {},
  studentQuestions: [],
  contracts: [],
  questionDetail: {},
  essaySSOUrl: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case success(actions.GET_EVALUATIONS):
      return {
        ...state,
        evaluations: helpers.getEvaluations(action.payload.content),
        years: helpers.getYears(action.payload.content),
      };
    case failure(actions.GET_ES_FILTERS_COMPONENTS):
      return {
        ...state,
        filtersComponents: initialState.filtersComponents,
      };
    case success(actions.GET_ES_FILTERS_COMPONENTS):
      return {
        ...state,
        filtersComponents: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        gradeByDiscipline: initialState.gradeByDiscipline,
      };
    case success(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        gradeByDiscipline: action.payload.content,
      };
    case request(actions.GET_ESGRADE_REPORT_STUDENT):
      return {
        ...state,
        gradeReportStudent: initialState.gradeReportStudent,
      };
    case success(actions.GET_ESGRADE_REPORT_STUDENT):
      return {
        ...state,
        gradeReportStudent: action.payload.content,
      };
    case failure(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS):
      return {
        ...state,
        questionsComponent: initialState.questionsComponent,
      };
    case success(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS):
      return {
        ...state,
        questionsComponent: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT):
      return {
        ...state,
        alternativeReport: initialState.alternativeReport,
      };
    case success(actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT):
      return {
        ...state,
        alternativeReport: action.payload.content,
      };
    case failure(actions.GET_ES_EVALUATIONS_CICLE_STUDENT):
      return {
        ...state,
        cicleStudent: initialState.cicleStudent,
      };
    case success(actions.GET_ES_EVALUATIONS_CICLE_STUDENT):
      return {
        ...state,
        cicleStudent: action.payload.content.question,
      };
    case request(actions.GET_ESGRADE_DETAIL_BY_STUDENT):
      return {
        ...state,
        gradeDetailStudent: initialState.gradeReportStudent,
      };
    case success(actions.GET_ESGRADE_DETAIL_BY_STUDENT):
      return {
        ...state,
        gradeDetailStudent: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_STUDENT_QUESTIONS):
      return {
        ...state,
        studentQuestions: initialState.studentQuestions,
      };
    case success(actions.GET_ESGRADE_STUDENT_QUESTIONS):
      return {
        ...state,
        studentQuestions: action.payload.content.questions,
      };
    case success(actions.GET_GROUPS):
      return {
        ...state,
        groups: action.payload.content,
        contracts: helpers.getContracts(action.payload.content),
        years: helpers.getYears(action.payload.content),
      };
    case failure(actions.GET_ES_QUESTION_DETAIL):
      return {
        ...state,
        questionDetail: initialState.questionDetail,
      };
    case success(actions.GET_ES_QUESTION_DETAIL):
      return {
        ...state,
        questionDetail: action.payload.content,
      };
    case request(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: initialState.essaySSOUrl,
      };
    case success(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: action.payload.content,
      };
    case failure(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: initialState.essaySSOUrl,
      };
    default:
      return state;
  }
};

export default reducer;
